
import { Link } from 'react-router-dom';

const chairs = [
  {
    key: 'pro',
    name: 'MeVER Chair Pro v1.1',
    badge: 'FLAGSHIP',
    tagline: 'プロフェッショナルのための究極の座り心地',
    description: '6Dアームレスト、4Dヘッドレスト、15ヶ所のフルアジャスト機能。長時間のクリエイティブワークに最適化されたフラッグシップモデル。',
    price: '¥123,200',
    priceNote: '税込（Black）',
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/18555a65f21397adfed78720e8be08d7.png',
    highlights: ['4Dヘッドレスト', '6Dアームレスト', 'フルアジャスタブル設計', '135°リクライニング'],
    comingSoon: false,
  },
  {
    key: 'core',
    name: 'MeVER Chair Core v1.0',
    badge: 'STANDARD',
    tagline: '必要十分の人間工学設計',
    description: 'Pro譲りのランバーサポートと4Dアームレストを搭載。シンプルながらも本格的な人間工学チェア。',
    price: '¥79,200',
    priceNote: '税込（Black）',
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/f4a7d90296f789d46c6753357c7a51a3.png',
    highlights: ['4Dアームレスト', '調整式ランバーサポート', 'シートスライド', '4Dヘッドレスト（別売り）'],
    comingSoon: true,
  },
  {
    key: 'style',
    name: 'MeVER Chair Style v1.0',
    badge: 'MINIMAL',
    tagline: '空間と調和するデザイン',
    description: 'インテリアに溶け込む洗練されたデザインと快適性を両立。リビングやホームオフィスに最適なライフスタイルモデル。',
    price: '¥69,300',
    priceNote: '税込（Black）',
    image: 'https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/0e5886a34ba8b9935f350bf408063f8e.png',
    highlights: ['ミニマルモダンデザイン', '3Dアームレスト', 'ファブリックシート', 'ロッキング機能'],
    comingSoon: false,
  },
];

export default function ChairLineupModels() {
  return (
    <section id="lineup" className="py-20 sm:py-28 md:py-36 bg-white" aria-labelledby="lineup-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-14 sm:mb-20">
          <h2
            id="lineup-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-4 tracking-[0.1em]"
          >
            3 Models, Your Choice
          </h2>
          <p className="text-sm sm:text-base font-extralight text-black/50 tracking-wide max-w-xl mx-auto">
            用途・体型・空間に合わせて選べる3つのモデル
          </p>
        </div>

        <div className="space-y-16 sm:space-y-24 md:space-y-32">
          {chairs.map((chair, index) => (
            <article
              key={chair.key}
              className={`grid lg:grid-cols-2 gap-10 sm:gap-14 lg:gap-20 items-center ${
                index % 2 === 1 ? 'lg:direction-rtl' : ''
              }`}
            >
              {/* Image */}
              <div className={`${index % 2 === 1 ? 'lg:order-2' : 'lg:order-1'}`}>
                <div className="relative aspect-[5/6] bg-gray-50 rounded-xl sm:rounded-2xl overflow-hidden group">
                  <img
                    src={chair.image}
                    alt={`${chair.name} - ${chair.tagline}`}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                    width="600"
                    height="720"
                  />
                  <div className="absolute top-4 left-4 flex flex-col gap-2">
                    <span className="px-3 py-1.5 bg-black/80 text-white text-[10px] sm:text-xs font-medium tracking-widest rounded">
                      {chair.badge}
                    </span>
                    {chair.comingSoon && (
                      <span className="px-3 py-1.5 bg-[#8E7AB5] text-white text-[10px] sm:text-xs font-medium tracking-wide rounded flex items-center gap-1">
                        <i className="ri-time-line text-xs" aria-hidden="true"></i>
                        発売準備中
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className={`${index % 2 === 1 ? 'lg:order-1' : 'lg:order-2'}`}>
                <span className="inline-block text-xs font-light text-[#8E7AB5] tracking-[0.2em] mb-3 sm:mb-4 uppercase">
                  {chair.badge}
                </span>
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-extralight text-black mb-2 sm:mb-3 tracking-[0.05em]">
                  {chair.name}
                </h3>
                <p className="text-base sm:text-lg font-extralight text-black/60 mb-4 sm:mb-6 tracking-wide">
                  {chair.tagline}
                </p>
                <p className="text-sm sm:text-base font-extralight text-black/50 leading-relaxed mb-6 sm:mb-8 tracking-wide">
                  {chair.description}
                </p>

                {/* Highlights */}
                <ul className="grid grid-cols-2 gap-x-4 gap-y-3 mb-8 sm:mb-10" aria-label={`${chair.name}の特徴`}>
                  {chair.highlights.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm font-light text-black/70">
                      <i className="ri-check-line text-[#8E7AB5] mt-0.5 flex-shrink-0" aria-hidden="true"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                {/* Price */}
                <div className="flex items-baseline gap-3 mb-6 sm:mb-8">
                  <span className="text-3xl sm:text-4xl font-light text-black tracking-tight">
                    {chair.price}
                  </span>
                  <span className="text-xs sm:text-sm font-extralight text-black/40">
                    {chair.priceNote}
                  </span>
                </div>

                {/* CTA */}
                <div className="flex flex-wrap items-center gap-3">
                  <Link
                    to={`/chair/${chair.key}`}
                    className="inline-flex items-center gap-2 px-7 sm:px-8 py-3 sm:py-3.5 bg-black text-white text-sm font-light tracking-[0.08em] hover:bg-black/80 transition-colors whitespace-nowrap rounded-md cursor-pointer group"
                    aria-label={`${chair.name}の詳細ページへ`}
                  >
                    詳細を見る
                    <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  </Link>
                  <a
                    href="https://appointment.mever.design/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-1.5 px-5 sm:px-6 py-3 sm:py-3.5 border border-black/15 text-black/70 text-sm font-light tracking-wide hover:bg-black hover:text-white transition-all whitespace-nowrap rounded-md cursor-pointer"
                    aria-label={`${chair.name}を体験予約する`}
                  >
                    <i className="ri-calendar-check-line text-sm" aria-hidden="true"></i>
                    体験予約
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
